import React, { useMemo, useState } from 'react';
import '../super-admin.css';
import { mockUsers } from '../mockData';

const DeleteAccount = () => {
  const [users, setUsers] = useState(mockUsers);
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(null);
  const filtered = useMemo(() => {
    const q = query.toLowerCase();
    return users.filter(u => `${u.name} ${u.email}`.toLowerCase().includes(q));
  }, [users, query]);

  const onDelete = () => {
    if (!selected) return;
    setUsers(prev => prev.filter(u => u.id !== selected));
    setSelected(null);
    alert('Deleted (demo)');
  };

  return (
    <div className="sa-content">
      <h1>Delete Account</h1>
      <div className="section">
        <p>Search and permanently delete a user account.</p>
        <input placeholder="Search user..." value={query} onChange={e => setQuery(e.target.value)} />
        <div style={{ marginTop: 8 }}>
          <select value={selected || ''} onChange={(e) => setSelected(Number(e.target.value) || null)}>
            <option value="">-- select user --</option>
            {filtered.map(u => (
              <option key={u.id} value={u.id}>{u.name} ({u.email})</option>
            ))}
          </select>
          <button onClick={onDelete} disabled={!selected} style={{marginLeft:8, background:'#ef4444', color:'#fff'}}>Delete</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
